export const CATEGORIES_LIST_URL = "/categories/custom/list-of-categories";

const SUCCESS_STATUS_CODES = [200, 304];

let cachedCategories = null;
let inFlightRequest = null;

export function getCachedCategories() {
  return cachedCategories;
}

export function invalidateCategoriesCache() {
  cachedCategories = null;
  inFlightRequest = null;
}

export function mapCategoryItems(items = []) {
  return items.map(({ id, name, slug }) => ({
    id,
    name,
    slug,
  }));
}

export function isSuccessfulCategoriesStatus(statusCode) {
  return SUCCESS_STATUS_CODES.includes(statusCode);
}

export function loadCategoriesCatalog(request) {
  if (cachedCategories) {
    return Promise.resolve(cachedCategories);
  }

  if (inFlightRequest) {
    return inFlightRequest;
  }

  inFlightRequest = Promise.resolve()
    .then(() => request({ url: CATEGORIES_LIST_URL }))
    .then((res) => {
      if (!isSuccessfulCategoriesStatus(res?.statusCode)) {
        throw new Error(res?.message || "Error al traer las categorías");
      }

      cachedCategories = mapCategoryItems(res?.data?.items ?? []);
      inFlightRequest = null;
      return cachedCategories;
    })
    .catch((error) => {
      inFlightRequest = null;
      throw error;
    });

  return inFlightRequest;
}
